import { api } from './api'
import { Appointment, AppointmentFormData, AppointmentFilters } from '../types/appointment'

export const appointmentService = {
  /**
   * Get all appointments with optional filters
   */
  getAll: async (filters?: AppointmentFilters): Promise<Appointment[]> => {
    const response = await api.get<Appointment[]>('/appointments', {
      params: filters,
    })
    return response.data
  },

  /**
   * Get appointment by ID
   */
  getById: async (id: string): Promise<Appointment> => {
    const response = await api.get<Appointment>(`/appointments/${id}`)
    return response.data
  },

  /**
   * Get appointments for a specific patient
   */
  getByPatient: async (patientId: string): Promise<Appointment[]> => {
    const response = await api.get<Appointment[]>(`/appointments`, {
      params: { patientId },
    })
    return response.data
  },

  /**
   * Get appointments for a specific staff member
   */
  getByStaff: async (staffId: string): Promise<Appointment[]> => {
    const response = await api.get<Appointment[]>(`/appointments`, {
      params: { staffId },
    })
    return response.data
  },

  /**
   * Create a new appointment
   */
  create: async (data: AppointmentFormData): Promise<Appointment> => {
    const response = await api.post<Appointment>('/appointments', data)
    return response.data
  },

  /**
   * Update an appointment
   */
  update: async (id: string, data: Partial<AppointmentFormData>): Promise<Appointment> => {
    const response = await api.put<Appointment>(`/appointments/${id}`, data)
    return response.data
  },

  /**
   * Cancel an appointment
   */
  cancel: async (id: string, reason?: string): Promise<Appointment> => {
    const response = await api.put<Appointment>(`/appointments/${id}/cancel`, { reason })
    return response.data
  },

  /**
   * Mark an appointment as DNA (Did Not Attend)
   */
  markAsDNA: async (id: string, reason?: string): Promise<Appointment> => {
    const response = await api.put<Appointment>(`/appointments/${id}/dna`, { reason })
    return response.data
  },

  /**
   * Mark an appointment as arrived
   */
  markAsArrived: async (id: string): Promise<Appointment> => {
    const response = await api.put<Appointment>(`/appointments/${id}/arrived`)
    return response.data
  },

  /**
   * Revert an appointment from arrived status
   */
  revertArrived: async (id: string): Promise<Appointment> => {
    const response = await api.put<Appointment>(`/appointments/${id}/revert-arrived`)
    return response.data
  },

  /**
   * Delete an appointment
   */
  delete: async (id: string): Promise<void> => {
    await api.delete(`/appointments/${id}`)
  },

  /**
   * Get available time slots for a staff member on a specific date
   */
  getAvailableSlots: async (staffId: string, date: string): Promise<string[]> => {
    const response = await api.get<string[]>(`/appointments/available-slots`, {
      params: { staffId, date },
    })
    return response.data
  },
}






























